import type { Messages } from '../types'
import { adminCommerceMessages } from './admin-commerce'
import { trailerMessages } from './trailer'

export const ja = {
  adminCommerce: adminCommerceMessages.ja,
  trailerRefresh: trailerMessages.ja,
  home: {
    quotaFull: 'フォロー上限に達しました。メンバープランをご確認ください。',
    search: '品番・女優・タイトルで検索',
    updates: 'フォロー中の新着',
    updatesBody: 'フォローしている女優の新作をまとめてチェック。',
    following: 'フォロー中の女優',
    followingBody: '女優を選ぶと、その人の新着だけを表示します。',
    discover: '気ままに見てみよう',
    discoverBody: 'ライブラリからランダムに選んだ作品です。気になるものを探してみましょう。',
    shuffle: '別の作品を見る',
    scrollPrevious: '{section}：左へスクロール',
    scrollNext: '{section}：右へスクロール',
    favorites: 'お気に入りを振り返る',
    favoritesBody: '保存した作品をもう一度 · 発売日順',
    noSubscriptionsBody:
      '気になる女優を一人フォローしてみましょう。フォローすると、作品がここに表示されます。',
    noUpdates: 'フォロー中の女優の新着はまだありません',
    noUpdatesBody: 'フォローはそのままです。新着を待つ間に、ほかの作品も探してみましょう。',
    noFavorites: 'お気に入りはまだありません。気になる作品のハートを押すと、ここから見返せます。',
    noDiscovery: '表示できる作品がありません。しばらくしてからご確認ください。',
  },

  admin7: {
    overviewHint: 'ローカルの業務データ。外部サービスの稼働状況は未確認です',
    orders: '注文確認',
    config: '基本設定',
    content: 'コンテンツ管理',
    tasks: 'タスク管理',
    empty: '記録がありません',
    unknown: 'リクエストの結果が不明です。元のリクエストの受領記録を確認し、再送信しないでください。',
    recover: '元のリクエストを確認',
    receipt: '確認済みの受領記録',
    newRequest: '別の操作を開始',
    requestKey: 'リクエストキー',
    role: 'ロール',
    saveRole: 'ロールの変更を確定',
    user: '一般ユーザー',
    admin: '管理者',
    details: '詳細を見る',
    save: '保存',
    readBack: '現在の状態を再取得',
    loading: '読み込み中…',
    email: 'メールアドレス',
    userId: 'ユーザー ID',
    id: 'レコード ID',
    status: '状態',
    source: '取得元',
    editActressSource: '女優の取得元を修正',
    sourceIdentifier: 'JavBus 取得元 ID',
    currentSource: '現在の取得元 ID',
    sourceHint:
      '保存では取得元のみを変更し、取得処理は開始しません。プロフィールを更新する場合は、別途「女優プロフィールを更新」を選んでください。',
    sourceFormat: '英数字・アンダースコア・ハイフンで 1〜80 文字。先頭は英数字',
    sourceConflict: '取得元が変更されています。現在の値を再取得してから、保存するか判断してください。',
    reloadSource: '取得元を再取得',
    continueEditing: '編集を続ける',
    trailerMaintenance: '個別作品の予告編管理',
    trailerHint:
      '選択した作品だけを処理します。新しい予告編の処理が成功するまで既存のファイルを保持します。キュー登録後はタスクの状態を確認でき、キャンセルも申請できます。',
    trailerMode: '予告編の追加方法',
    trailerAuto: '自動検索',
    trailerUrl: '公開予告編 URL',
    trailerFile: 'ローカルの予告編ファイル',
    trailerUrlHint:
      'DMM、MGS、カリビアンなど、許可された公開予告編のパスに対応しています。それ以外はローカルファイルをご利用ください。',
    trailerFileHint: 'MP4 または MPEG-TS、最大 200 MiB。ファイルの内容はサーバーで検証されます。',
    uploading:
      'アップロードと受領確認を待っています。このページを開いたままにしてください。タイムアウト後は元のタスクの確認のみ行ってください。',
    all: 'すべて',
    amount: '金額',
    created: '作成日時',
    paid: '支払日時',
    expires: '有効期限',
    providerStatus: '決済サービス側の状態',
    merchantOrder: '加盟店注文番号',
    orderHint:
      'Payment 注文を読み取り専用で確認します。独立した Stars 台帳は含まず、決済照会や特典の付与も行いません。通貨ごとに表示します。',
    revenue: '今月の CCPayment 支払済み金額（USD）',
    revenueHint: 'UTC の月境界、USD のみ。Stars・CDKey・手動付与分は含みません',
    limit: '1 日の無料登録枠',
    translationUrl: '翻訳サービス URL',
    model: '翻訳モデル',
    translationKey: '翻訳 API キー',
    appId: 'CCPayment App ID',
    paymentKey: 'CCPayment キー',
    fiat: '価格表示の法定通貨 ID',
    coin: '価格表示の暗号資産 ID',
    configured: '設定済み。空欄で保持',
    unset: '未設定',
    configHint:
      'キーの元の値は表示されません。空欄なら保持されます。保存後はマスキング済みの設定を返しますが、外部サービスの検証完了を意味しません。',
    recent: '最近のコンテンツを取得',
    actressCrawl: '女優の作品を取得',
    videoRefresh: '作品を更新',
    actressRefresh: '女優プロフィールを更新',
    translateVideo: '作品を個別翻訳',
    translateBatch: '件数を指定して一括翻訳',
    kind: '操作',
    target: '対象の内部 ID',
    pages: '最大ページ数（1〜10）',
    batchLimit: '一括処理の上限（1〜50）',
    enqueue: 'キューへの登録を確定',
    taskHint:
      'キューへの登録は処理の完了を意味しません。ページを離れてもタスクはキャンセルされません。キャンセルは選択したタスクにのみ適用されます。',
    active: '実行待ち・実行中のタスク',
    history: 'タスク履歴',
    cancelTask: 'このタスクのキャンセルを申請',
    cancellation: 'キャンセルを申請しました。実行側の最終状態を待っています',
    progress: '処理 {processed} / {total} · 成功 {success} · 失敗 {failed}',
    attempts: '試行 {attempts} / {max}',
    errorCode: 'エラーコード',
    taskId: 'タスク ID',
    searchActress: '登録済みの女優を検索',
    searchVideo: '品番またはタイトルで検索',
    searchBound: '2 文字以上入力してください。最大 20 件を表示します',
    noContent: '一致するコンテンツがありません。検索語を変えてください',
    selectedContent: '選択中：{name}',
    search: '検索',
    select: '選択',
    unavailableStar: 'JavBus Star ID がありません',
    translationTitle: '翻訳タイトルを手動修正',
    videoId: '作品の内部 ID',
    locale: '言語',
    title: 'タイトル',
    translationSaved: '翻訳タイトルを保存しました',
    viewUser: '特典を管理',
    snapshot: '現在の特典終了日時',
    manualHint:
      '通常は有効な特典の終了後に期間を追加します。期限切れの場合は現在時刻から計算します。永久特典のダウングレードはできません。',
    months: '月数（1〜120）',
    expectedEnd: '終了予定日時（サーバーの受領結果が確定値）',
    membershipConflict:
      '特典の状態またはリクエストが競合しています。ユーザーの状態を再取得してから操作してください。',
    replaceLifetimeEffect: '置き換え後は永久特典となり、有効期限はなくなります。',
    replaceFiniteEffect:
      '置き換え後は今回の適用時刻から {months} か月になります。現在の残り期間は引き継がれず、有効期間が短くなる場合があります。',
    append: '特典期間を追加',
    replace: '特典を置き換え',
    mode: '特典の操作',
    reason: '操作メモ',
    replaceConfirm: '選択したプランで現在の特典を置き換え、有効期間が短くなる可能性があることを確認しました',
  },
  brand: { name: 'JAV Tracker', admin: '管理画面' },
  nav: {
    today: '今日',
    discover: '見つける',
    library: 'ライブラリ',
    search: '検索',
    me: 'マイページ',
    searchPlaceholder: '品番・女優・タグで検索',
    account: 'アカウントメニュー',
    logout: 'ログアウト',
    admin: '管理画面',
    language: '言語',
    back: '戻る',
    backTo: '{target}に戻る',
    skipToContent: 'メインコンテンツへスキップ',
  },
  common: {
    retry: '再試行',
    loading: '読み込み中…',
    loadMore: 'もっと見る',
    loadError: '読み込めませんでした。再試行してください',
    networkError: 'ネットワークに接続できません',
    cancel: 'キャンセル',
    apply: '適用',
    clearAll: 'すべてクリア',
    confirm: '確認',
    close: '閉じる',
    copy: 'コピー',
    copied: 'コピーしました',
    copyFailed: 'コピーできませんでした。選択して手動でコピーしてください',
    videosCount: '{count} 本',
    viewAll: 'すべて見る',
    upgrade: 'アップグレード',
    end: 'すべて表示しました',
    autoPaused: '{count} 本を読み込みました。続きを見るには手動で読み込んでください',
    unknownOutcome: 'リクエストの結果が不明なため、サーバーに確認しています…',
    unknownPending: 'リクエストの結果がまだ確認できません。状態を確認してから続けてください。',
    verifyState: '状態を確認',
    mockNotice: 'Mock データのプレビュー · すべて架空のサンプルです',
  },
  video: {
    retranslate: '再翻訳',
    retranslateHint: 'この作品のタイトルを再翻訳します。手動修正は保持され、完了後に翻訳が更新されます。',
    new: '新着',
    magnets: 'マグネット {count}',
    noMagnets: 'マグネット待ち',
    trailer: '予告編',
    solo: '単独出演',
    favorite: 'お気に入り',
    favorited: 'お気に入り済み',
    unfavorite: 'お気に入りから削除',
    copyCode: '品番をコピー',
    coverAlt: '{code} のジャケット',
    coverFallback: 'ジャケット',
    releaseDate: '発売日',
    duration: '収録時間',
    minutes: '{count} 分',
    maker: 'メーカー',
    series: 'シリーズ',
    cast: '出演',
    tags: 'タグ',
    translated: '翻訳',
    original: '日本語の原文',
    playTrailer: '予告編を再生',
    closeTrailer: '予告編を閉じる',
    trailerLabel: '{code} の予告編',
    trailerError: '予告編を読み込めないか、再生できません。再試行してください。',
    trailerUnsupported:
      'このブラウザーは予告編の形式に対応していません。MediaSource 対応のブラウザーをご利用ください。',
    trailerPlayBlocked: 'ブラウザーが自動再生を停止しました。下の再生ボタンをご利用ください。',
    trailerHint: '予告編はクリック後に読み込まれます。',
    noTrailer: '予告編はありません',
    copyBest: 'おすすめのマグネットをコピー',
    bestMeta: '{size} · シード {seeders} · {source}',
    bestRule: 'シード数とサイズで自動選択',
    noMagnetYet: 'マグネットがありません。更新をお試しください',
    allMagnets: 'すべてのマグネット',
    magnetCount: '{count} 件',
    refreshMagnets: 'マグネットを更新',
    refreshQuota: '本日の残り {remaining}/{limit}',
    refreshing: '更新中…',
    colName: '名前',
    colSize: 'サイズ',
    colSeeders: 'シード',
    colSource: '取得元',
    best: 'おすすめ',
    notFound: '作品が見つかりません',
    notFoundBody:
      '品番が間違っているか、まだ登録されていない可能性があります。オンライン検索をお試しください。',
  },
  actress: {
    recrawl: '再取得',
    recrawlHint: '最近の作品を取得・保存します（最大5ページ）。タスク終了後に作品一覧を更新します。',
    subscribe: 'フォロー',
    subscribed: 'フォロー中',
    pending: '確認中…',
    unknown: '再確認',
    unsubscribe: 'フォローを解除',
    works: '作品',
    soloOnly: '単独出演',
    withCompilations: '総集編を含む',
    pushing: '新作を Telegram に通知します',
    pushOff: 'Telegram を連携すると新作通知を受け取れます',
    debut: 'デビュー',
    birthday: '生年月日',
    height: '身長',
    measurements: 'スリーサイズ',
    videoTotal: '作品',
    limitReached: '無料プランでフォローできる女優は 5 人までです',
    notFound: '女優が見つかりません',
  },
  today: {
    title: '今日の新着',
    summary: '前回の訪問以降に新作 {count} 本 · フォロー中の女優 {actresses} 人',
    all: 'すべて',
    manage: 'フォローを管理',
    hasMagnets: 'マグネットあり',
    hasTrailer: '予告編あり',
    unfavorited: 'お気に入り未登録',
    sortRelease: '発売日順',
    today: '今日',
    yesterday: '昨日',
    groupCount: '{count} 本',
    emptyNoSubs: 'フォロー中の女優はいません',
    emptyNoSubsBody: 'フォローすると、新作が発売日順にここに表示されます。',
    goDiscover: '女優を探す',
    emptyFiltered: 'この条件に合う作品はありません',
    emptyFilteredBody: '条件を変えるか、フィルターを解除してすべての新着をご覧ください。',
    quotaTitle: '無料プラン · 女優のフォロー',
    quotaFull: '上限に達しました。メンバーならフォロー無制限・広告なし',
    viewPlans: 'メンバープランを見る',
  },
  discover: {
    title: '見つける',
    videos: '作品',
    actresses: '女優',
    tags: 'タグ',
    filter: '絞り込み',
    filterCount: '絞り込み · {count}',
    filterDraft: '未適用の条件',
    applied: '適用中：',
    onlyShow: '表示する作品',
    solo: '単独出演作品',
    hasMagnets: 'マグネットあり',
    hasTrailer: '予告編あり',
    favorited: 'お気に入りのみ',
    releaseWindow: '発売時期',
    anyTime: '指定なし',
    days30: '30 日以内',
    thisYear: '今年',
    tag: 'タグ',
    sortLabel: '作品の並び順',
    sortNewest: '発売日 · 新しい順',
    sortOldest: '発売日 · 古い順',
    sortCrawledNewest: '取得日 · 新しい順',
    sortCrawledOldest: '取得日 · 古い順',
    pageAt: '{page} ページを表示中',
    jump: '移動',
    jumpLabel: 'ページ番号へ移動',
    actressFilter: '名前・日本語名・ローマ字',
    all: 'すべて',
    subscribedOnly: 'フォロー中',
    unsubscribedOnly: '未フォロー',
    hotTags: '人気のタグ',
    hotTagsHint: 'サイト全体のお気に入り数順',
    searchTags: 'すべてのタグを検索',
    expand: '残り {count} 件を表示',
    collapse: '折りたたむ',
    tagFilterActive: 'タグ：{name}',
  },
  tagCategory: {
    QUALITY_FORMAT: '画質・形式',
    RELEASE_LABEL: '発売レーベル',
    BODY_PERSONA: '体型・キャラクター',
    ROLE_COSTUME: '役柄・衣装',
    RELATION_CAST: '関係性・出演者',
    GENRE_SCENARIO: 'ジャンル・シチュエーション',
    PLAY_FETISH: 'プレイ・嗜好',
    OTHER: 'その他',
  },
  library: {
    title: 'ライブラリ',
    favorites: 'お気に入り作品 · {count}',
    favoritesTab: 'お気に入り作品',
    subscriptions: 'フォロー中の女優 · {count}',
    favoritedAt: '{actress}',
    latest: '最新 {code}',
    quota: '無料プランの上限',
    emptyFavorites: 'お気に入りの作品はまだありません',
    emptyFavoritesBody: '作品カードのハートを押すと、お気に入りに追加できます。',
    emptySubs: 'フォロー中の女優はまだいません',
  },
  search: {
    title: '検索',
    placeholder: '品番・女優・タグで検索',
    scopeAll: 'すべて',
    scopeVideos: '作品',
    scopeActresses: '女優',
    scopeTags: 'タグ',
    exact: '品番の完全一致',
    videos: '作品',
    actresses: '女優',
    tags: 'タグ',
    open: '↵ 開く',
    recent: '最近の検索',
    clearRecent: 'クリア',
    noLocal: '登録済みの作品に見つかりませんか？JavBus をオンライン検索',
    onlineHint: '結果はライブラリに追加されます。キャッシュがある場合は回数を消費しません',
    onlineButton: '「{keyword}」をオンライン検索',
    onlineQuota: '本日の残り {remaining}/{limit}',
    onlineRunning: 'オンライン検索中… {count} 本見つかりました',
    onlineDone: 'オンライン検索が完了しました。{count} 本見つかりました',
    onlineCancel: '停止',
    onlineCancelled: '結果の受信を停止しました。追加済みの作品は削除されません',
    onlineExhausted: '本日のオンライン検索回数を使い切りました',
    keyboardHints: '↑↓ 選択 · ↵ 開く · Esc 閉じる',
    typeToSearch: '2 文字以上入力してください',
    searching: '検索中…',
    noResult: '登録済みのデータに一致する結果はありません',
    kindCode: '品番',
    kindVideo: '作品',
    kindActress: '女優',
    kindTag: 'タグ',
  },
  me: {
    defaultLanguage: 'デフォルトの言語',
    defaultLanguageHint:
      'Telegram の新作通知と詳細リンクに使用します。未設定の場合は繁体字中国語です。表示言語は個別に変更できます。',
    defaultLanguageSaved: 'デフォルトの言語を保存しました',

    title: 'マイページ',
    overview: '概要',
    membership: 'メンバーシップと支払い',
    telegram: 'Telegram 通知',
    cdkey: 'CDKey を引き換える',
    security: '言語とセキュリティ',
    free: '無料プラン',
    active: 'メンバー',
    expired: '期限切れ',
    lifetime: '永久メンバー',
    until: '有効期限：{date}',
    verifyBanner:
      'メールアドレスが未確認です。CDKey の引き換え、メンバーシップの購入、Telegram の連携にはメール認証が必要です。',
    resendVerify: '認証メールを再送信',
    verifySent: '認証メールを送信キューに登録しました。しばらくしてからご確認ください',
    quotaSubs: '女優のフォロー',
    quotaOnline: 'オンライン検索 · 本日',
    quotaRefresh: 'マグネット更新 · 本日',
    perks:
      'メンバーはフォロー・操作回数が無制限、広告なし。暗号資産でお支払いいただくと、入金確認後に自動で有効になります。',
    monthly: '月額',
    yearly: '年額',
    lifetimePlan: '永久',
    perMonth: '/ 月',
    perYear: '/ 年',
    oneTime: '買い切り',
    bestValue: 'おすすめ',
    choose: '{plan}を選択',
    price: '[価格]',
    orderPaid: '支払いが完了し、メンバー特典が有効になりました。',
    orderCancelled: '注文は終了しました。この注文によるメンバーシップは有効になっていません。',
    orderUnknown: '支払い注文はまだ確認中です。元の注文を確認し、新しい注文を重複して作成しないでください。',
    goCheckout: '支払いに進む',
    checkOrder: '元の注文を確認',
    tgUnknown: '操作の結果がまだ確認できません。連携状態を確認し、リクエストを自動で再送信しないでください。',
    tgRegenerate: '再発行すると以前の連携コードは無効になります。',
    tgCopy: '連携コマンドをコピー',
    tgOpenBot: 'ボットを開く',
    tgCheck: '連携状態を確認',
    cdkeyConfirm: '元の引き換えリクエストを確認',
    cdkeyUnknown:
      '引き換え結果が不明なため、メンバー状態を再取得しました。元のリクエストを確認してください。別のコードに変えて再送信しないでください。',
    orderPending:
      '注文を作成しました。支払いの確認待ちです。ページを閉じても入金処理に影響はありません。特典はサーバーでの確認後に有効になります。',
    tgBound: '@{username} と連携済み',
    tgUnbound: '未連携',
    tgBody: 'フォロー中の女優の新作を通知します。初回連携で 7 日間のメンバーシップを受け取れます。',
    tgRewarded: '初回連携特典は受け取り済みです',
    tgTest: 'テストメッセージを送信',
    tgTestSent: 'テストメッセージを送信キューに登録しました',
    tgUnbind: '連携を解除',
    tgBind: '連携コードを取得',
    tgCode: 'Telegram でボットに送信してください：{code}',
    cdkeyLabel: '引き換えコードを入力',
    cdkeyRedeem: '引き換える',
    cdkeyNeedVerify: 'メール認証後に利用できます',
    cdkeyDone: '引き換えが完了し、メンバーシップが有効になりました',
    cdkeyHint: 'Mock 用コード：DEMO-CDKEY-2026',
    language: '表示言語',
    changePassword: 'パスワードを変更',
    logout: 'ログアウト',
  },
  auth: {
    login: 'ログイン',
    register: '新規登録',
    email: 'メールアドレス',
    password: 'パスワード',
    optional: '任意',
    forgot: 'パスワードを忘れた方',
    submitLogin: 'ログイン',
    submitRegister: 'アカウントを作成',
    demoLink: 'まずはゲスト用デモを見る →',
    passwordRule: '英字と数字を含む 8 文字以上、72 バイト以下（日本語や絵文字は複数バイト）',
    headline: '気になる女優をフォローして、\n新作をいち早くチェック。',
    mockHint: 'Mock アカウント：demo@example.com または admin@example.com、パスワード：password1',
    terms: '利用規約',
    privacy: 'プライバシーポリシー',
    forgotTitle: 'パスワードをリセット',
    forgotBody:
      '登録したメールアドレスを入力してください。Telegram 連携済みの場合は Telegram に、それ以外はメールで送信します。',
    forgotSubmit: 'リセットリンクを送信',
    forgotDoneTitle: 'リクエストを受け付けました',
    forgotDone:
      '対象となるアカウントにはリセットリンクを送信する手配を行います。この表示は配信完了を示すものではありません。{seconds} 秒後に再申請できます。',
    forgotResend: '再送信',
    forgotPrivacy: 'アカウントの有無がわからないよう、すべてのメールアドレスに同じ案内を表示します。',
    backToLogin: 'ログインに戻る',
    forgotHeadline: 'パスワードを忘れても、\nフォローした女優はそのまま。',
    resetTitle: '新しいパスワードを設定',
    resetBody: '完了すると、すべての端末からログアウトされます。',
    newPassword: '新しいパスワード',
    confirmPassword: 'もう一度入力',
    show: '表示',
    hide: '隠す',
    ruleLength: '8 文字以上（絵文字などは 2 文字と数える場合があります）',
    ruleBytes: '72 バイト以下（日本語や絵文字は複数バイト）',
    ruleMix: '英字と数字を含む',
    ruleMatch: '2 回の入力が一致',
    resetSubmit: '新しいパスワードを保存',
    resetExpired: 'リンクが期限切れ、または使用済みですか？',
    resetAgain: 'もう一度申請 →',
    resetDone: 'パスワードを更新しました。再度ログインしてください',
    resetHeadline: '新しい鍵に交換すると、\nほかの端末は自動でログアウト。',
    verifyingTitle: 'メールアドレスを確認中…',
    verifiedTitle: 'メールアドレスを確認しました',
    verifiedBody:
      'CDKey の引き換え、メンバーシップの購入、Telegram の連携による新作通知が利用できるようになりました。',
    goBindTelegram: 'Telegram を連携する',
    backToday: '今日に戻る',
    verifyFailedTitle: 'メール認証が完了していません',
    verifyFailedBody:
      'エラー内容をご確認ください。リンクが無効な場合は、ログイン後に認証メールを再申請できます。',
    registerEmailFailed:
      'アカウントは作成されましたが、認証メールの送信キュー登録はまだ確認できません。アカウントページから再申請できます。',
    alreadyVerified: 'メール認証済み',
    currentPassword: '現在のパスワード',
    logoutAll: 'すべての Web セッションからログアウト',
    logoutAllDone: 'Web セッションからログアウトしました。再度ログインしてください',
    resendVerify: '認証メールを再送信',
    goLogin: 'ログインへ',
  },
  jobs: {
    nextPage: '次のページをオンライン検索',
    cancelling: 'キャンセルを申請しました。確認待ちです',
    confirmRequest: '元のリクエストを確認',
    resume: 'タスクに再接続',
    unknown:
      '送信結果はまだ確認できません。元のリクエストを確認する際は同じリクエスト番号を使用し、既存のタスクを重複して作成することはありません。',
    disconnected:
      'タスクは引き続き実行されている可能性があります。接続が切れてもキャンセルされません。再接続して状態を確認できます。',
    partial: '利用可能な結果を一部取得しました。利用可能な結果に基づいて回数を精算します。',
  },
  onboarding: {
    step1: '女優を選ぶ',
    step2: '作品をお気に入りに追加',
    step3: 'Telegram を連携',
    step4: '完了',
    progress: '{current} / 1 · {label}',
    skip: 'スキップ',
    title: 'まずは気になる女優を選びましょう',
    body: 'まずは 3 人がおすすめ。最大 5 人まで選べます。新作は「今日」に表示され、Telegram でも通知を受け取れます。',
    selected: '{count} / 5 人を選択中',
    continue: '{count} 人をフォローして続ける',
    needOne: '1 人以上選んでください',
  },
  landing: {
    navigation: 'ホームのナビゲーション',
    eyebrow: 'あなただけの新作チェックリスト',
    signupFree: '無料アカウントを作成',
    heroA: '好きな人をフォローして、',
    heroB: '新作を見逃さない。',
    heroBody:
      '気になる女優、残しておきたい作品、新作の情報をひとまとめに。JAV Tracker を開けば、自分に関係のある更新がすぐに見つかります。',
    seePreview: '新作チェックの流れを見る',
    loginHint:
      'ログインすると作品の閲覧やフォロー・お気に入りの管理ができます。登録枠は登録ページでご確認ください。',
    previewTitle: 'フォロー中の新着',
    example: '新着チェックの例',
    sampleOne: 'フォロー中の女優の新作をひとまとめに',
    sampleTwo: '気になる作品はその場でお気に入りに',
    sampleAvailable: 'マグネット登録済み',
    previewNote: 'Telegram を連携すると、新作通知も受け取れます。',
    exampleNote:
      '上記は機能のイメージです。品番と内容は架空のサンプルであり、リアルタイムの更新ではありません。',
    how: '使い方',
    howTitle: 'フォローから始めて、新作チェックを日常に。',
    f1Title: '気になる人を見つける',
    f1Body: '女優名・品番・タイトルで検索して、作品や女優のプロフィールを確認できます。',
    f2Title: 'フォローして、自分だけの新着一覧を作る',
    f2Body:
      'フォロー中の女優をまとめて管理し、作品を発売日順に確認できます。気に入った作品は個別にお気に入りへ。',
    f3Title: '見に来るか、通知で受け取る',
    f3Body:
      'ホームでフォロー中の新着を確認できます。Telegram を自分で連携すれば、そちらでも新作通知を受け取れます。',
    pricingTitle: '無料で始めて、必要に応じてメンバーに',
    pricingBody:
      '無料アカウントで作品の閲覧、お気に入りへの追加、女優のフォローができます。フォローやオンライン操作には上限があり、現在の利用可能回数はログイン後に確認できます。',
    membershipBody:
      'もっと利用したくなったら、メンバープランをご覧ください。特典・料金・購入の可否は、アカウント内の表示をご確認ください。',
    viewMembership: 'ログインしてメンバープランを見る',
    startTitle: 'まずは好きな女優を一人フォロー。',
    startBody: '次にホームを開くとき、楽しみが待っています。',
    sessionError: '現在ログイン状態を確認できません。ホームの内容は引き続きご覧いただけます。',
    termsTitle: 'サービスについて',
    termsBody:
      'JAV Tracker は成人向けの作品情報管理・新作追跡ツールです。第三者の作品情報は遅れたり無効になったりする場合があります。お住まいの地域で認められる範囲でご利用ください。',
    termsContact: '利用規約の全文を問い合わせる ↗',
    privacyTitle: 'プライバシーについて',
    privacyBody:
      'ログイン状態の維持に Cookie を使用します。フォローやお気に入りはアカウントに紐づきます。Telegram の連携は自分で有効にし、アカウント内から解除できます。ここでは機能の概要のみをご案内しています。完全なポリシーやデータに関するご相談はサポートへお問い合わせください。',
    privacyContact: 'プライバシーポリシー・データに関するお問い合わせ ↗',
    rights: '© JAV Tracker',
  },
  admin: {
    overview: 'ダッシュボード',
    users: 'ユーザー',
    crawler: 'クローラー管理',
    groupOverview: '概要',
    groupUsers: 'ユーザー・収益',
    groupContent: 'コンテンツ',
    groupCrawl: '収集',
    groupSystem: 'システム',
    revenue: '収益',
    cdkeys: 'CDKey',
    videos: '作品',
    aliases: '女優の別名',
    translations: '翻訳タスク',
    crawlerLogs: 'クローラーログ',
    config: 'システム設定',
    monitor: '監視',
    notInScope: '初版では未提供です',
    backToApp: '← アプリに戻る',
    refresh: '更新',
    telegramTest: 'Telegram テストを送信',
    statVideos: '作品',
    statActresses: '女優',
    statUsers: 'ユーザー',
    statRevenue: '今月の収益',
    statTranslations: '翻訳待ち',
    statQueue: 'バックグラウンドキューの失敗',
    delta24h: '+{count} 過去 24 時間',
    delta7d: '+{count} 過去 7 日間',
    activeMembers: '有効なメンバー {count} 人',
    sinceMonth: '北京時間の月初から',
    ingest: '新規登録作品 · 過去 14 日間',
    sample: 'Mock データ',
    deps: '外部サービス',
    recentJobs: '最近のバックグラウンドタスク',
    usersSub: 'ユーザー {count} 人 · 管理者はメール認証の制限対象外です',
    searchEmail: 'メールアドレスで検索',
    filterAll: 'すべて',
    filterActive: '有効なメンバー',
    filterFree: '無料',
    filterExpired: '期限切れ',
    filterAdmin: '管理者',
    colEmail: 'メールアドレス',
    colRole: 'ロール',
    colMembership: 'メンバーシップ',
    colTelegram: 'Telegram',
    colSubs: 'フォロー',
    colCreated: '登録日',
    roleAdmin: '管理者',
    roleUser: 'ユーザー',
    bound: '連携済み',
    unbound: '未連携',
    activate: 'メンバーシップを有効化',
    activateTitle: 'メンバーシップを手動で有効化',
    current: '現在：{status}',
    activateFooter: 'プランの定価を収益に計上し、監査ログに記録します。',
    activateConfirm: '有効化を確定',
    activateDone: '{email} を有効化しました',
    pageOf: '{page} ページ',
    prev: '前のページ',
    next: '次のページ',
    crawlerSub: '内蔵スケジューラーが 3 時間ごとにキューへ登録 · normal カテゴリーのみ',
    startIncremental: 'サイト全体の差分取得を開始',
    jobTitle: '作品の取得 · normal',
    running: '実行中',
    finished: '今回の処理が完了',
    stop: '停止を申請',
    slice: '今回の slice · 作品 {processed} / {total}',
    sliceMeta: 'ページ {pages} / {pageLimit} · {elapsed}s / {budget}s',
    okCount: '今回の成功数',
    failCount: '失敗',
    failHint: '次の slice で再試行します',
    notifyCount: '新作通知',
    notifyHint: '通知キューに登録済み',
    slots: '全体の同時実行枠',
    slotsHint: 'インスタンス間で共有',
    crawlActress: '女優を個別に取得',
    starLabel: 'JavBus 女優 ID または名前',
    enqueue: 'キューに追加',
    enqueueDone: 'キューに追加しました：{jobId}',
    enqueueHint: '同じ女優のタスクが既にある場合は、そのタスクを返します。重複して作成しません。',
    liveLogs: 'リアルタイムログ',
    liveHint: '5 秒ごとに更新',
    forbidden: '管理者権限が必要です',
  },
  membership: {
    FREE: '無料',
    ACTIVE: '有効',
    EXPIRED: '期限切れ',
    MONTHLY: '月額',
    YEARLY: '年額',
    LIFETIME: '永久',
  },
} satisfies Messages
